import { MRT_ColumnDef } from 'material-react-table';

import { LimitPosition } from '../../../types/limitPosition';

export const limitColumns: MRT_ColumnDef<LimitPosition>[] = [
  { accessorKey: 'clientCode', header: 'Клиентский счет', enableColumnFilter: false, size: 130 },
  { accessorKey: 'security', header: 'Security key', enableColumnFilter: false, size: 130 },
  { accessorKey: 'depo', header: 'Счет DEPO', enableColumnFilter: false, size: 120 },
  { accessorKey: 'tag', header: 'Tag', enableColumnFilter: false, size: 180 },
  { accessorKey: 'kind', header: 'Тип', enableColumnFilter: false, size: 110 },
  { accessorKey: 'number', header: 'Количество', enableColumnFilter: false, size: 110 },
  { accessorKey: 'price', header: 'Цена', enableColumnFilter: false, size: 100 },
  { accessorKey: 'currency', header: 'Валюта', enableColumnFilter: false, size: 90 },
  { accessorKey: 'varMargin', header: 'VarMargin', enableColumnFilter: false, size: 120 },
];
